import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { IconButton, Tooltip } from "@mui/material";

import { useDialog } from "../../../../../common/components/dialog/useDialog";
import { useGetLazyPaginatedSKUs } from "../hooks/useGetLazyPaginatedSKUs";
import { ISKUDeviceData, ISKUForm } from "../variables/skuData";
import CreateSKUDialog from "./CreateSKUDialog";

interface DuplicateSKUContainerProps {
  row: {
    skuNumber?: string;
    configurationName?: string;
    skuDataConfigurations?: string;
    defaultIp?: string;
  };
}

const DuplicateSKUContainer = ({
  row,
}: DuplicateSKUContainerProps): JSX.Element => {
  const { open, handleDialogOpen, handleDialogClose } = useDialog();
  const { data } = useGetLazyPaginatedSKUs();

  const existingConfigurationNames =
    data?.getSKUs?.items
      .map(item => item?.configurationName)
      .filter((name): name is string => Boolean(name)) ?? [];

  let parsedData: ISKUDeviceData[] = [];

  try {
    parsedData = JSON.parse(row.skuDataConfigurations ?? "[]");
  } catch {
    parsedData = [];
  }

  const initialValues: ISKUForm = {
    skuNumber: row.skuNumber ?? "",
    configurationName: row.configurationName ?? "",
    password: parsedData[0]?.password ?? "",
    hasRecordVideo: parsedData[0]?.hasRecordVideo ?? true,
    skuDataConfigurations: parsedData,
  };

  return (
    <>
      <Tooltip title="Create editable duplicate of this SKU">
        <IconButton size="small" onClick={handleDialogOpen}>
          <ContentCopyOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      {open && (
        <CreateSKUDialog
          open={open}
          handleClose={handleDialogClose}
          mode="duplicate"
          initialValues={initialValues}
          existingConfigurationNames={existingConfigurationNames}
        />
      )}
    </>
  );
};

export default DuplicateSKUContainer;
